var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 47",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Files-Manager---v3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16---Opening-a-folder-lv1-",
    transform: "translate(-288.000000, -816.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(245.000000, 701.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(43.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9750693,5.78947368 L25.9279778,5.78947368 L20.166205,0 L5.76177285,0 C2.59423823,0 0,2.60671053 0,5.78947368 L0,40.5263158 C0,43.7090789 2.59423823,46.3157895 5.76177285,46.3157895 L50.4155125,46.3157895 C52.8628255,46.3157895 54.7368421,44.4327632 54.7368421,41.9736842 L54.7368421,11.5789474 C54.7368421,8.39618421 52.1426039,5.78947368 48.9750693,5.78947368",
    id: "Fill-1",
    fill: "#FFA000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2910595,14.7368421 L15.7299174,14.7368421 C13.0017647,14.7368421 10.5660676,16.7435407 10.1345521,19.4751196 L5.26315789,46.3157895 L50.7070438,46.3157895 C53.4337629,46.3157895 55.8708936,44.3090909 56.3009755,41.577512 L59.8849912,21.4818182 C60.6017944,18.0397129 57.8750752,14.7368421 54.2910595,14.7368421",
    id: "Fill-3",
    fill: "#FFCA28"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.772c2044f4bf1da12e9fd122f4b3ca4c.svg";
export { ForwardRef as ReactComponent };